var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"max-w-sm animate-pulse col-span-full gap-0 mt-4 inline-flex flex-col self-center",attrs:{"role":"status"}},[_c('div',{staticClass:"h-2.5 bg-gdc-gray-200 rounded-full w-48 w-full mb-4"}),_vm._v(" "),_c('div',{staticClass:"h-2.5 bg-gdc-gray-200 rounded-full w-48 w-full mb-4"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])
}]

export { render, staticRenderFns }